/* eslint-disable */
import React, { useContext } from 'react';
import PaymentContext from '../../context/Payment/Context';
import ProductContext from '../../context/Product/Context';
import GlobalContext from '../../context/Global/Context';
import useProductDataByCountry from '../../hooks/useProductDataByCountry';
import totalPriceCarts from '../../hooks/totalCarts';

const organizeDataPayments = () => {
  const paymentContext = useContext(PaymentContext);
  const productContext = useContext(ProductContext);
  const globalContext = useContext(GlobalContext);
  const { carts, products } = productContext;
  const { address, hasAddress } = paymentContext;
  const { isCitaFlow, customerId } = globalContext;
  const [productsToShow, setProductsToShow] = React.useState([]);
  const totalCarts = totalPriceCarts(carts, false);
  const { currencyCode } = carts[0].totalPrice;
  localStorage.setItem('email', carts[0].customerEmail);

  const attributesCart = carts[0].lineItems[0].variant.attributes;

  const productKey = attributesCart.find(
    (value) => value.name === 'productKey'
  );

  const productCategory = attributesCart.find(
    (value) => value.name === 'productCategory'
  );

  if (productsToShow.length < products.length) {
    const converted = useProductDataByCountry(products, false, false);
    converted.forEach((obj) => {
      delete obj.images; // eslint-disable-line no-param-reassign
    });
    setProductsToShow(converted);
  }

  const addresLocal = {
    Street: hasAddress ? address.Street : 'street',
    Address_Number: hasAddress ? address.Address_Number : '123',
    Zip_Code: hasAddress ? address.Zip_Code : '00000',
    Neighborhood: hasAddress ? address.Neighborhood : 'colony',
    State: hasAddress ? address.State[0] : 'state',
    city: 'Ciudad',
    References: hasAddress ? address.References : 'reference',
  };

  const data = {
    payer: {
      address: {
        Street: hasAddress ? address.Street : 'street',
        Address_Number: hasAddress ? address.Address_Number : '123',
        Zip_Code: hasAddress ? address.Zip_Code : '00000',
        Neighborhood: hasAddress ? address.Neighborhood : 'colony',
        State: hasAddress ? address.State[1] : 'state',
        city: 'Ciudad',
        References: hasAddress ? address.References : 'reference',
      },
      name: localStorage.getItem('name'),
      phone: '000000000000',
      email: carts[0].customerEmail,
      customerId: carts[0].customerId
        ? carts[0].customerId
        : isCitaFlow
        ? customerId
        : carts[0].anonymousId,
    },
    cartData: {
      id: carts[0].id,
      currency: currencyCode,
      totalPrice: totalCarts,
      totalLineItemQuantity: products.length,
      lineItems: productsToShow,
      productCategory: productCategory ? productCategory.value : '',
      productKey: productKey ? productKey.value : '',
    },
  };

  localStorage.setItem('address', JSON.stringify(addresLocal));

  return data;
};

export default organizeDataPayments;
